/** A WhatsApp App account is usable for groups only after the QR session is linked. */
export const isActiveWhatsAppAppConnection = (connectionStatus?: string | null): boolean =>
  (connectionStatus ?? '').trim().toLowerCase() === 'open';
